export const ChartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 14H4.13333C3.38659 14 3.01323 14 2.72801 13.8547C2.47713 13.7269 2.27315 13.5229 2.14533 13.272C2 12.9868 2 12.6134 2 11.8667V2M4.66667 7V11.6667M7.66667 3.66667V11.6667M10.6667 7V11.6667M13.6667 3.66667V11.6667"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChartIcon;
